module.exports = __webpack_public_path__ + "355616e26838a5cf4b1af8acb3265e72.svg";